document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".acordion__item");

  accordionItems.forEach(function (item) {
    const headingBox = item.querySelector("[data-toggle-acordion-text]");
    const textBox = item.querySelector("[data-acordion-text]");
    const toggleButton = item.querySelector("button");
    const toggleIcon = item.querySelector("[data-acordion-icon]");

    headingBox.addEventListener("click", function () {
      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";

      // Zamknij wszystkie inne akordeony
      accordionItems.forEach(function (otherItem) {
        const otherTextBox = otherItem.querySelector("[data-acordion-text]");
        const otherButton = otherItem.querySelector("button");
        const otherIcon = otherItem.querySelector("[data-acordion-icon]");

        otherTextBox.style.display = "none";
        otherButton.setAttribute("aria-expanded", "false");
        otherIcon?.classList.remove("active");
      });

      // Jeśli obecny był zamknięty, otwórz go
      if (!isExpanded) {
        textBox.style.display = "block";
        toggleButton.setAttribute("aria-expanded", "true");
        toggleIcon?.classList.add("active");
      }
    });
  });
});
